import { render, staticRenderFns } from "./viewClassEnrollments.vue?vue&type=template&id=0cbbbede&scoped=true&class=m-0"
import script from "./viewClassEnrollments.vue?vue&type=script&lang=js"
export * from "./viewClassEnrollments.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0cbbbede",
  null
  
)

export default component.exports